/**
 * Detect the backend "no route data" condition.
 *
 * When an office has no computed CleverRoute paths/metrics, the metrics endpoint
 * responds with a 400 whose body message contains "No paths found ..."
 * (e.g. `[VALIDATION_ERROR] Failed to fetch metrics: No paths found for
 * project_id=…, company_id=…, office_id=…`). In that case the map should show a
 * friendly hint dialog instead of trying to render (empty) map layers.
 *
 * The rejected value from JmApi.get is the parsed JSON error body
 * (`{ code, message, success }`), so we inspect its `message`.
 */
export function isNoRouteDataError(error: unknown): boolean {
  const anyErr = error as { message?: unknown } | null | undefined;
  const message =
    anyErr && typeof anyErr.message === "string"
      ? anyErr.message
      : typeof error === "string"
        ? error
        : "";
  return /no paths found/i.test(message);
}
